import { DownloadSimpleIcon } from "@phosphor-icons/react/dist/csr/DownloadSimple";
import { Button } from "@volca/ui/components/ui/button";
import { Card } from "@volca/ui/components/ui/card";
import { Stack } from "@volca/ui/components/ui/stack";
import { Text } from "@volca/ui/components/ui/text";
import { PayrollRunStatusBadge } from "@/payroll/pay-periods/payroll-run-status-badge";
import { RelativeTime } from "@/payroll/pay-periods/relative-time";
import type { IPayrollRun } from "@/payroll/payroll.d";

interface LegacyScriptOutputStateProps {
  run: IPayrollRun;
  onDownload: () => void;
}

export const LegacyScriptOutputState = ({
  run,
  onDownload,
}: LegacyScriptOutputStateProps) => (
  <Stack
    justify="center"
    align="center"
    className="min-h-[300px] w-full"
    gap={4}
  >
    <Text variant="heading">Payroll is available for this period.</Text>
    <Card className="w-full max-w-4xl gap-0 overflow-hidden py-0">
      <Stack align="start" gap={4} className="w-full p-4">
        <Stack
          direction="row"
          align="center"
          justify="between"
          gap={2}
          className="w-full flex-wrap"
        >
          <Stack direction="row" align="center" gap={2}>
            <PayrollRunStatusBadge status={run.status} />
            <Stack align="start" gap={0} className="min-w-0">
              <Text className="wrap-break-word">
                Requested by {run.user_display_name || "Volca Admin"}
              </Text>
              <RelativeTime
                timestamp={run.created_at}
                className="text-subtle"
              />
            </Stack>
          </Stack>
          <Button variant="default" size="sm" onClick={onDownload}>
            <DownloadSimpleIcon data-icon="inline-start" />
            Download
          </Button>
        </Stack>
      </Stack>
    </Card>
  </Stack>
);
